// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';

// const CaseStudies = () => {
//   const [activeTab, setActiveTab] = useState(0);

//   // Case Study Data Array
//   const cases = [
//     {
//       id: 0,
//       shortTitle: "Antimicrobial Surveillance",
//       fullTitle: "Scalable Relational Architecture for Multidisciplinary Antimicrobial Surveillance",
//       tag: "15+ YEAR PROJECT",
//       sector: "Public Health / Agricultural Research",
//       challenge: "A high-level health services client required a robust system to track antimicrobial use (AMU) across various livestock commodities. Previous attempts by multiple consultants over three years had failed to produce a sustainable database. Data was trapped in flat files (SAS/SPSS/Stata), preventing a unified longitudinal view.",
//       strategy: "The project began with a deep-dive into the biological and operational 'logic' of the surveillance. We engineered a 4-level deep relational model in PostgreSQL (Survey > Route > Medicated Record > Specific Agents).",
//       results: [
//         "Core architecture has remained stable and operational for over 15 years.",
//         "Transition across commodities (Swine to Beef/Turkeys) was seamless due to logic-based schema.",
//         "Significantly reduced data cleaning time for PhD-level epidemiologists."
//       ],
//       quote: "The engine remained the same; only the parameters changed."
//     },
//     {
//       id: 1,
//       shortTitle: "Wildlife Health Infrastructure",
//       fullTitle: "National Wildlife Health Surveillance: From Fragmented Silos to National Infrastructure",
//       tag: "12+ YEAR PROJECT",
//       sector: "Veterinary Science / Epidemiological Research",
//       challenge: "Four distinct regional sites operated independent Paradox databases. Data integration was manual and occurred only once per year, preventing real-time insights during high-stakes events like the West Nile Virus outbreak.",
//       strategy: "A three-phase evolutionary modernization: UI improvement via Delphi, migration to a centralized MySQL relational structure, and finally an enterprise-grade transition to PostgreSQL on Linux.",
//       results: [
//         "Unified national surveillance platform for cross-domain veterinary data.",
//         "Successfully supported national West Nile Virus tracking for 4+ years.",
//         "Infrastructure supported a team expansion to five employees without architectural strain."
//       ],
//       quote: "Transitioned from fragile legacy silos to robust national infrastructure without loss of research continuity."
//     },
//     {
//       id: 2,
//       shortTitle: "The Statistical Bridge",
//       fullTitle: "The Bridge: Engineering 'Analyst-Ready' Data Pipelines",
//       tag: "CORE PHILOSOPHY",
//       sector: "Statistical Pipeline Optimization",
//       challenge: "Software engineers often build databases that store data efficiently but are difficult for statisticians to extract. Researchers often spend 60% of their time 'cleaning' data rather than analyzing it.",
//       strategy: "Because our leadership background is in Statistics, we build automated translation layers that format data instantly for SAS, SPSS, Stata, and R during the database export process.",
//       results: [
//         "Elimination of manual structural organization errors.",
//         "Data is delivered pre-validated and model-ready.",
//         "Bridging the gap between raw engineering and high-level scientific research."
//       ],
//       quote: "I don't just store your data—I ensure it is clean, structured, and ready for the analysis that drives your mission."
//     }
//   ];

//   return (
//     <div style={{ fontFamily: 'Inter, sans-serif', color: '#0f172a', backgroundColor: '#fcfcfd', minHeight: '100vh' }}>
      
//       {/* 1. TOP NAVIGATION & HEADER */}
//       <nav style={navStyle}>
//         <Link to="/" style={{ textDecoration: 'none', color: '#007bff', fontWeight: '700' }}>← Return to Home</Link>
//       </nav>

//       <header style={headerStyle}>
//         <h1 style={{ fontSize: '36px', fontWeight: '900', marginBottom: '10px' }}>Technical Case Studies</h1>
//         <p style={{ color: '#64748b', fontSize: '18px' }}>Proven architectural solutions for institutional and research data.</p>
//       </header>

//       {/* 2. TAB SELECTOR */}
//       <div style={tabBarContainer}>
//         <div style={tabBar}>
//           {cases.map((c) => (
//             <button 
//               key={c.id} 
//               onClick={() => setActiveTab(c.id)}
//               style={activeTab === c.id ? activeTabStyle : inactiveTabStyle}
//             >
//               {c.shortTitle}
//             </button>
//           ))}
//         </div>
//       </div>

//       {/* 3. CASE CONTENT AREA */}
//       <main style={contentContainer}>
//         <div style={contentCard}>
//           <div style={tagStyle}>{cases[activeTab].tag}</div>
//           <h2 style={fullTitleStyle}>{cases[activeTab].fullTitle}</h2>
//           <p style={sectorStyle}>Sector: {cases[activeTab].sector}</p>

//           <div style={gridStyle}>
//             <div style={textBlock}>
//               <h4 style={subheadStyle}>The Challenge</h4>
//               <p style={pStyle}>{cases[activeTab].challenge}</p>
//             </div>
//             <div style={textBlock}>
//               <h4 style={subheadStyle}>The Strategy</h4>
//               <p style={pStyle}>{cases[activeTab].strategy}</p>
//             </div>
//           </div>

//           <div style={resultsBlock}>
//             <h4 style={{ color: '#007bff', marginBottom: '15px' }}>Key Impact & Results</h4>
//             <ul style={listStyle}>
//               {cases[activeTab].results.map((res, i) => (
//                 <li key={i}>{res}</li>
//               ))}
//             </ul>
//           </div>

//           <div style={quoteBlock}>
//              "{cases[activeTab].quote}"
//           </div>
//         </div>
//       </main>

//       <footer style={{ textAlign: 'center', padding: '60px 20px', color: '#94a3b8', fontSize: '14px' }}>
//         Yellow Ray Consulting Group Inc. | Case Study Archive
//       </footer>
//     </div>
//   );
// };

// // ================= STYLES =================

// const navStyle = { padding: '20px 40px', borderBottom: '1px solid #e2e8f0', backgroundColor: '#fff' };
// const headerStyle = { padding: '60px 20px', textAlign: 'center' };

// const tabBarContainer = { display: 'flex', justifyContent: 'center', marginBottom: '40px', padding: '0 20px' };
// const tabBar = { display: 'flex', backgroundColor: '#f1f5f9', padding: '6px', borderRadius: '12px', border: '1px solid #e2e8f0' };

// const inactiveTabStyle = {
//   padding: '12px 24px', border: 'none', backgroundColor: 'transparent', cursor: 'pointer',
//   borderRadius: '8px', fontSize: '14px', fontWeight: '600', color: '#64748b', transition: '0.2s'
// };

// const activeTabStyle = {
//   ...inactiveTabStyle, backgroundColor: '#fff', color: '#007bff', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
// };

// const contentContainer = { maxWidth: '1000px', margin: '0 auto', padding: '0 20px 80px' };
// const contentCard = { backgroundColor: '#fff', border: '1px solid #e2e8f0', borderRadius: '16px', padding: '50px', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.05)' };

// const tagStyle = { color: '#007bff', fontWeight: '800', fontSize: '12px', letterSpacing: '1.5px', marginBottom: '10px' };
// const fullTitleStyle = { fontSize: '32px', fontWeight: '800', marginBottom: '8px', lineHeight: '1.2' };
// const sectorStyle = { color: '#94a3b8', fontSize: '13px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '40px' };

// const gridStyle = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '40px', marginBottom: '40px' };
// const textBlock = { textAlign: 'left' };
// const subheadStyle = { fontSize: '18px', fontWeight: '700', marginBottom: '12px' };
// const pStyle = { fontSize: '16px', color: '#475569', lineHeight: '1.7' };

// const resultsBlock = { backgroundColor: '#f8fafc', padding: '30px', borderRadius: '12px', marginBottom: '30px', textAlign: 'left' };
// const listStyle = { paddingLeft: '20px', color: '#334155', lineHeight: '1.8' };
// const quoteBlock = { fontSize: '18px', fontStyle: 'italic', color: '#64748b', borderTop: '1px solid #e2e8f0', paddingTop: '30px', textAlign: 'center' };

// export default CaseStudies;


import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const CaseStudies = () => {
  // 0 = Core Philosophy (Landing), 1 = Antimicrobial, 2 = Wildlife
  const [activeTab, setActiveTab] = useState(0);

  const philosophy = {
    shortTitle: "The Statistical Bridge",
    fullTitle: "Engineering 'Analyst-Ready' Data Pipelines",
    tag: "CORE PHILOSOPHY - The Bridge",
    sector: "Institutional Methodology",
    challenge: "Traditional software engineering often creates 'data silos' that are efficient for storage but a nightmare for extraction. Researchers and statisticians frequently spend up to 60% of their time cleaning and restructuring data before any actual analysis can occur.",
    strategy: "Because our leadership background is rooted in Statistics and Mathematics, we build 'The Bridge.' We architect relational models with the end-analysis in mind, integrating automated translation layers that format data instantly for SAS, SPSS, Stata, and R during the database export process.",
    results: [
      "Elimination of manual structural organization errors.",
      "Data delivered pre-validated and model-ready for PhD-level analysis.",
      "Ensures technical infrastructure evolves with scientific requirements."
    ],
    quote: "We don't just store your data—we ensure it is clean, structured, and ready for the analysis that drives your mission."
  };

  const projects = [
    {
      id: 1,
      shortTitle: "Antimicrobial Surveillance",
      fullTitle: "Scalable Relational Architecture for Multidisciplinary Antimicrobial Surveillance",
      tag: "15+ YEAR PROJECT",
      sector: "Public Health / Agricultural Research",
      challenge: "A high-level health services client required a robust system to track antimicrobial use (AMU) across various livestock commodities. Previous attempts by multiple consultants over three years had failed. Data was trapped in flat files, preventing a unified longitudinal view.",
      strategy: "We engineered a 4-level deep relational model in PostgreSQL (Survey > Route > Medicated Record > Specific Agents). Built on logic rather than hard-coded variables, the system allows for seamless cross-commodity expansion.",
      results: [
        "Core architecture has remained stable and operational for over 15 years.",
        "Transitioned across commodities (Swine to Beef/Turkeys) without database rebuilds.",
        "Significantly reduced data cleaning time for epidemiological teams."
      ],
      quote: "The engine remained the same; only the parameters changed."
    },
    {
      id: 2,
      shortTitle: "Wildlife Health Infrastructure",
      fullTitle: "National Wildlife Health: From Fragmented Silos to National Infrastructure",
      tag: "12+ YEAR PROJECT",
      sector: "Veterinary Science / Epidemiological Research",
      challenge: "A national research group was struggling with four regional sites operating independent Paradox databases. Manual integration occurred only once per year, preventing real-time tracking of public health threats like West Nile Virus.",
      strategy: "A three-phase modernization: Upgrading UI via custom Delphi environments, migrating to a centralized MySQL relational structure, and final scaling to PostgreSQL on Linux for national-level stability.",
      results: [
        "Unified national surveillance platform for cross-domain veterinary data.",
        "Supported national West Nile Virus tracking for 4+ consecutive years.",
        "Architecture scaled from a single user to a national team without downtime."
      ],
      quote: "Moving from fragile legacy silos to robust national infrastructure without loss of research continuity."
    }
  ];

  const currentData = activeTab === 0 ? philosophy : projects.find(p => p.id === activeTab);

  return (
    <div style={{ fontFamily: 'Inter, sans-serif', color: '#0f172a', backgroundColor: '#fcfcfd', minHeight: '100vh' }}>
      
      <nav style={navStyle}>
        <Link to="/" style={{ textDecoration: 'none', color: '#64748b', fontSize: '14px' }}>Home</Link> 
        <span style={{ margin: '0 10px', color: '#cbd5e1' }}>&gt;</span>
        <span style={{ color: '#0f172a', fontWeight: '700', fontSize: '14px' }}>Technical Case Studies</span>
      </nav>

      <header style={headerStyle}>
        <h1 style={{ fontSize: '36px', fontWeight: '900', marginBottom: '10px' }}>Technical Case Studies & Methodology</h1>
        <p style={{ color: '#64748b', fontSize: '18px' }}>How we build for longevity and analytical precision.</p>
      </header>

      {/* TABS CONTAINER */}
      <div style={tabBarContainer}>
        
        {/* PRIMARY TAB: PHILOSOPHY */}
        <div style={{ marginBottom: '15px', textAlign: 'center' }}>
          <button 
            onClick={() => setActiveTab(0)}
            style={activeTab === 0 ? activePhilosophyTab : philosophyTab}
          >
            ⭐ The Statistical Bridge
          </button>
        </div>

        {/* SECONDARY TABS: PROJECTS */}
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '15px' }}>
          <span style={{ fontSize: '11px', fontWeight: '800', color: '#94a3b8', letterSpacing: '1px' }}>CASE STUDIES:</span>
          <div style={tabBar}>
            {projects.map((p) => (
              <button 
                key={p.id} 
                onClick={() => setActiveTab(p.id)}
                style={activeTab === p.id ? activeProjectTab : projectTab}
              >
                {p.shortTitle}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* CONTENT AREA */}
      <main style={contentContainer}>
        <div style={{ ...contentCard, borderTop: activeTab === 0 ? '6px solid #6366f1' : '6px solid #007bff' }}>
          <div style={tagStyle}>{currentData.tag}</div>
          <h2 style={fullTitleStyle}>{currentData.fullTitle}</h2>
          <p style={sectorStyle}>Focus: {currentData.sector}</p>

          <div style={gridStyle}>
            <div style={textBlock}>
              <h4 style={subheadStyle}>The Challenge</h4>
              <p style={pStyle}>{currentData.challenge}</p>
            </div>
            <div style={textBlock}>
              <h4 style={subheadStyle}>The Strategy</h4>
              <p style={pStyle}>{currentData.strategy}</p>
            </div>
          </div>

          <div style={resultsBlock}>
            <h4 style={{ color: activeTab === 0 ? '#6366f1' : '#007bff', marginBottom: '15px' }}>Measurable Impact</h4>
            <ul style={listStyle}>
              {currentData.results.map((res, i) => (
                <li key={i}>{res}</li>
              ))}
            </ul>
          </div>

          <div style={quoteBlock}>
             "{currentData.quote}"
          </div>
        </div>
      </main>

      <footer style={{ textAlign: 'center', padding: '60px 20px', color: '#94a3b8', fontSize: '14px' }}>
        Yellow Ray Consulting Group Inc. | Technical Archive 2026
      </footer>
    </div>
  );
};

// ================= STYLES =================

const navStyle = { padding: '20px 40px', backgroundColor: '#fff', borderBottom: '1px solid #e2e8f0' };
const headerStyle = { padding: '60px 20px 40px', textAlign: 'center' };

const tabBarContainer = { maxWidth: '800px', margin: '0 auto 50px' };
const philosophyTab = { 
  padding: '14px 30px', border: '1px solid #e2e8f0', backgroundColor: '#fff', cursor: 'pointer',
  borderRadius: '12px', fontSize: '15px', fontWeight: '700', color: '#475569', transition: '0.2s',
  boxShadow: '0 2px 4px rgba(0,0,0,0.02)'
};
const activePhilosophyTab = { ...philosophyTab, backgroundColor: '#6366f1', color: '#fff', borderColor: '#4f46e5', boxShadow: '0 10px 15px -3px rgba(99, 102, 241, 0.3)' };

const tabBar = { display: 'inline-flex', backgroundColor: '#f1f5f9', padding: '5px', borderRadius: '10px', border: '1px solid #e2e8f0' };
const projectTab = {
  padding: '10px 20px', border: 'none', backgroundColor: 'transparent', cursor: 'pointer',
  borderRadius: '7px', fontSize: '13px', fontWeight: '600', color: '#64748b', transition: '0.2s'
};
const activeProjectTab = { ...projectTab, backgroundColor: '#fff', color: '#007bff', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' };

const contentContainer = { maxWidth: '1000px', margin: '0 auto', padding: '0 20px 80px' };
const contentCard = { backgroundColor: '#fff', border: '1px solid #e2e8f0', borderRadius: '16px', padding: '50px', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.05)' };

const tagStyle = { color: '#6366f1', fontWeight: '800', fontSize: '12px', letterSpacing: '1.5px', marginBottom: '10px' };
const fullTitleStyle = { fontSize: '32px', fontWeight: '800', marginBottom: '8px', lineHeight: '1.2' };
const sectorStyle = { color: '#94a3b8', fontSize: '13px', fontWeight: '700', textTransform: 'uppercase', marginBottom: '40px' };

const gridStyle = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '40px', marginBottom: '40px' };
const textBlock = { textAlign: 'left' };
const subheadStyle = { fontSize: '18px', fontWeight: '700', marginBottom: '12px' };
const pStyle = { fontSize: '16px', color: '#475569', lineHeight: '1.7' };

const resultsBlock = { backgroundColor: '#f8fafc', padding: '30px', borderRadius: '12px', marginBottom: '30px', textAlign: 'left', border: '1px solid #e2e8f0' };
const listStyle = { paddingLeft: '20px', color: '#334155', lineHeight: '1.8' };
const quoteBlock = { fontSize: '18px', fontStyle: 'italic', color: '#94a3b8', borderTop: '1px solid #f1f5f9', paddingTop: '30px', textAlign: 'center' };

export default CaseStudies;